var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.googleVisible)?_c('div',{staticClass:"botones-sso"},[_vm._m(0),_c('button',{staticClass:"btn btn-custom-color-white border border-round-50 mw-100 my-2",attrs:{"type":"button","disabled":_vm.deshabilitado},on:{"click":_vm.ingresarConGoogle}},[_vm._v(" Ingresar con Google ")])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"botones-sso__separador"},[_c('span',[_vm._v("o")])])
}]

export { render, staticRenderFns }